import { mix, transparentize } from "polished";
export var dark = function dark(colour) {
  return mix(0.25, "#000", colour);
};
export var darker = function darker(colour) {
  return mix(0.4, "#000", colour);
};
export var muted = function muted(colour) {
  return mix(0.75, "#fff", colour);
};
export var light = function light(colour) {
  return mix(0.5, "#fff", colour);
};
export var transparent = function transparent(colour) {
  return transparentize(0.75, colour);
};
export var faded = function faded(colour) {
  return transparentize(0.3, colour);
};